import React from 'react'
import { IconFilter, IconX } from '@tabler/icons-react'
import { cn } from 'src/enviroment/lib/utils'
import Typography from '../atoms/Typography'

interface FilterTriggerProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Chip text; no chip while nothing is applied. */
  activeLabel: string | null
  onClear: (e: React.MouseEvent) => void
}

const FilterTrigger = React.forwardRef<HTMLButtonElement, FilterTriggerProps>(
  ({ activeLabel, onClear, className, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(
        'flex min-h-[50px] w-full items-center gap-2 rounded-lg border border-gray-300 bg-gray-800 px-3 py-2 text-gray-50 transition-colors hover:border-gray-400',
        className,
      )}
      {...props}
    >
      <IconFilter className="h-4 w-4" />
      <Typography variant="base" className="text-gray-200">
        Filter
      </Typography>
      {activeLabel && (
        <>
          <div className="h-5 w-[1px] bg-gray-300" />
          <div className="flex items-center gap-2 rounded-md bg-light-green-500 px-2 py-1">
            <Typography variant="sm-medium" className="text-gray-100">
              {activeLabel}
            </Typography>
            <IconX className="h-3 w-3 cursor-pointer text-gray-50 hover:text-light-green-400" onClick={onClear} />
          </div>
        </>
      )}
    </button>
  ),
)

FilterTrigger.displayName = 'FilterTrigger'

export default FilterTrigger
